<template>
  <el-container class="layout-container">
    <el-aside width="200px">
      <div class="logo">
        <h2>猫巷宠托师</h2>
      </div>
      <el-menu
        :default-active="activeMenu"
        :router="true"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <template v-for="menu in menuList">
          <el-submenu v-if="menu.children && menu.children.length > 0" :key="menu.id || menu.path" :index="menu.path">
            <template slot="title">
              <i :class="menu.icon || 'el-icon-menu'"></i>
              <span>{{ menu.name }}</span>
            </template>
            <el-menu-item
              v-for="child in menu.children"
              :key="child.id || child.path"
              :index="child.path"
            >
              <i :class="child.icon || 'el-icon-document'"></i>
              <span slot="title">{{ child.name }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else :key="menu.id " :index="menu.path">
            <i :class="menu.icon || 'el-icon-document'"></i>
            <span slot="title">{{ menu.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header>
        <div class="header-left">
          <span class="page-title">{{ currentTitle }}</span>
        </div>
        <div class="header-right">
          <el-dropdown v-if="userRoles.length > 0" trigger="click" @command="handleSwitchRole">
            <span class="role-switch-btn">
              <i class="el-icon-s-custom"></i>
              当前角色: {{ currentRole ? currentRole.name : '未选择' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item 
                v-for="role in userRoles" 
                :key="role.id" 
                :command="role"
                :class="{ 'is-active': currentRole && currentRole.id === role.id }"
              >
                {{ role.name }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <el-avatar :size="32" :src="avatarUrl" icon="el-icon-user"></el-avatar>
              <span>{{ userInfo.username || '管理员' }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="avatar">设置头像</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
    <avatar-cropper
      :visible.sync="avatarDialogVisible"
      title="设置头像"
      @confirm="handleCropComplete"
    ></avatar-cropper>
  </el-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { authApi, userApi, fileApi } from '@/api'
import AvatarCropper from '@/components/AvatarCropper.vue'

export default {
  name: 'Layout',
  components: {
    AvatarCropper
  },
  data() {
    return {
      defaultMenuList: [
        
      ],
      switchRoleLoading: false,
      avatarDialogVisible: false
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    ...mapState(['userInfo', 'menus', 'currentRole']),
    userRoles() {
      return this.userInfo.roles || []
    },
    menuList() {
      console.log('Menus from store:', this.menus)
      if (this.menus && this.menus.length > 0) {
        console.log('Using menus from store')
        return this.buildMenuTree(this.menus)
      }
      console.log('Using default menus')
      return this.defaultMenuList
    },
    activeMenu() {
      return this.$route.path
    },
    currentTitle() {
      return this.$route.meta.title || ''
    },
    avatarUrl() {
    console.log(this.userInfo.avatar)
      if (this.userInfo.avatar) {
        return this.$ossBaseURL + this.userInfo.avatar
      }
      return ''
    }
  },
  methods: {
    buildMenuTree(menus, parentId = 0) {
      const tree = []
      for (const menu of menus) {
        if (menu.parentId === parentId && menu.type !== 3) {
          const children = this.buildMenuTree(menus, menu.id)
          if (children.length > 0) {
            menu.children = children
          }
          tree.push(menu)
        }
      }
      return tree.sort((a, b) => (a.sort || 0) - (b.sort || 0))
    },
    async handleSwitchRole(role) {
      if (this.switchRoleLoading) return
      if (this.currentRole && this.currentRole.id === role.id) return
      
      this.switchRoleLoading = true
      try {
        const res = await authApi.selectRole(role.id)
        const { token, role: newRole, menus } = res.data
        this.$store.dispatch('login', {
          token,
          userInfo: this.userInfo,
          menus
        })
        this.$store.dispatch('setCurrentRole', newRole)
        this.$message.success('角色切换成功')
        this.$router.push('/dashboard')
      } catch (error) {
        console.error('Switch role error:', error)
        this.$message.error('角色切换失败')
      } finally {
        this.switchRoleLoading = false
      }
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: '警告'
        }).then(() => {
          this.$store.dispatch('logout')
          this.$router.push('/login')
        })
      } else if (command === 'avatar') {
        this.avatarDialogVisible = true
      }
    },
    async handleCropComplete(blob) {
      const loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      try {
        const uploadRes = await fileApi.uploadFile(blob)
        const tempFilePath = uploadRes.data.filePath
        
        const moveRes = await fileApi.moveToPublic(tempFilePath, 'avatar')
        const publicFilePath = moveRes.data.filePath
        
        await userApi.updateAvatar(this.userInfo.id, publicFilePath)
        
        this.$store.commit('SET_USER_INFO', {
          ...this.userInfo,
          avatar: publicFilePath
        })
        
        this.$message.success('头像更新成功')
        this.avatarDialogVisible = false
      } catch (error) {
        console.error('Update avatar error:', error)
        this.$message.error('头像更新失败')
      } finally {
        loading.close()
      }
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100%;
}

.el-aside {
  background-color: #304156;
  overflow-x: hidden;
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #1f2d3d;
}

.el-header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.header-right {
  display: flex;
  align-items: center;
}

.role-switch-btn {
  cursor: pointer;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-right: 20px;
  padding: 5px 12px;
  border-radius: 4px;
  transition: all 0.3s;
}

.role-switch-btn:hover {
  background-color: #f5f7fa;
}

.el-dropdown-link {
  cursor: pointer;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 8px;
}

.el-dropdown-item.is-active {
  color: #409EFF;
  background-color: #ecf5ff;
}

.el-main {
  background-color: #f0f2f5;
  padding: 20px;
  height: calc(100vh - 60px);
  overflow-y: auto;
}
</style>
